import { Suspense, useEffect, useState } from "react";
import ErrorBoundary from "../components/ErrorBoundary";
import { DynamicModulesInterface } from "../contexts/DynamicModuleProvider";
import { System } from "./dynamicModules";

interface LoadComponentProps {
  scope: DynamicModulesInterface;
}

interface SystemProps {
  url: String
  scope: String
  module: String
  title: String
}

export default function LoadComponent(props: LoadComponentProps) {
  const [system, setSystem] = useState<SystemProps>({
    url: "",
    scope: "",
    module: "",
    title: ""
  });
  const { application, name } = props.scope;

  useEffect(() => {
    setSystem({
      url: `${application?.host}?v=${new Date().getTime()}`,
      scope: application?.module_name || "",
      module: "./AppRoutes",
      title: name,
    });
  }, []);

  return (

    <Suspense fallback={"Loading..."}>
      <ErrorBoundary errorMessage={`Ocorreu um erro ao carregar a aplicação ${name}`}>
      <System system={system} />
      </ErrorBoundary>
    </Suspense>
  )
}
